import { store } from '../store/index';
import { logEvent } from './logEvent';

export const showError = (err) => {
  // Handle refresh token expired errors gracefully
  if (err?.isRefreshTokenError || err?.name === 'RefreshTokenExpiredError') {
    // Show user-friendly session expired message
    logEvent('PWA Session Expired', {
      errorTitle: 'Session Expired',
      errorDesc: err.message || 'Refresh token expired',
      userAgent: navigator.userAgent,
      currentRoute: window.location.pathname + window.location.search,
      timestamp: new Date().toISOString(),
    });

    store.dispatch({
      type: 'SHOW_ERROR',
      payload: {
        errorTitle: 'Session Expired',
        errorDesc: 'Your session has expired. Please login again',
      },
    });
    return;
  }

  let errorTitle = 'Something went wrong';
  let errorDesc =
    'We were unable to fulfill your request. Please try again later.';
  if (err?.response?.data?.errorMessage) {
    errorDesc = err.response.data.errorMessage;
  } else if (err?.data?.errorMessage) {
    errorDesc = err.data.errorMessage;
  }

  if (err?.response?.data?.errorHeader) {
    errorTitle = err.response.data.errorHeader;
  } else if (err?.data?.errorHeader) {
    errorTitle = err.data.errorHeader;
  }
  if (err.message === 'Network Error') {
    errorTitle = 'Network Error';
    errorDesc =
      'Something went wrong in connecting to server. Please try again later.';
  }

  if (err.response?.status === 403) {
    errorDesc =
      'Forbidden: Your IP may be blocked due to VPN or suspicious activity.';
  }
  if (err.response?.status === 401) {
    store.dispatch({
      type: 'SET_INITIAL_STATE',
    });
  }

  logEvent('PWA Error', {
    errorTitle: errorTitle,
    errorDesc: errorDesc,
    status: err.response?.status || 'No Response',
    userAgent: navigator.userAgent,
    origin: window.location.origin,
    requestedUrl: err.config?.url, // assuming axios
    method: err.config?.method,
    headers: err.config?.headers,
    currentRoute: window.location.pathname + window.location.search,
    timestamp: new Date().toISOString(),
    message: err.message,
    isCorsSuspected: err.message === 'Network Error' && !err.response,
  });

  store.dispatch({
    type: 'SHOW_ERROR',
    payload: {
      errorTitle: errorTitle,
      errorDesc: errorDesc,
    },
  });
};
